import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/authentication-service/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'templates',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/message-templates/message-templates.module').then(m => m.MessageTemplatesModule),
  },
  {
    path: 'compose-message',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/compose-message/compose-message.module').then(m => m.ComposeMessageModule)
  },
  {
    path: 'hub-config',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/hub-config/hub-config.module').then(m => m.HubConfigModule)
  },
  // {
  //   path: 'self-provisioning',
  //   canActivate: [AuthGuard],
  //   loadChildren: () => import('./components/self-provisioning/self-provisioning.module').then(m => m.SelfProvisioningModule)
  // },
  {
    path: 'inbox',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/inbox/inbox.module').then(m => m.InboxModule)
  },
  {
    path: 'outbox',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/outbox/outbox.module').then(m => m.OutboxModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./components/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'provisioned-numbers',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/provisioned-numbers/provisioned-numbers.module').then(m => m.ProvisionedNumbersModule)
  },
  {
    path: 'dpm-admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/dpm-admin/dpm-admin.module').then(m => m.DpmAdminModule)
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/change-password/change-password.module').then(m => m.ChangePasswordModule)
  },
  {
    path: 'keyword-management',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/keyword-management/keyword-management.module').then(m => m.KeywordManagementModule)
  }, {
    path: 'hours-of-operation',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/opening-hours/opening-hours.module').then(m => m.OpeningHoursModule)
  }
  // {
  //   path: 'support',
  //   canActivate: [AuthGuard],
  //   loadChildren: () => import('./components/support/support.module').then(m => m.SupportModule)
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
